/* Orvani — pan, pinch y rueda dentro del diálogo de zoom del producto. */
(function () {
  'use strict';

  var ICON_IN = '<svg viewBox="0 0 24 24" aria-hidden="true"><line x1="12" y1="6" x2="12" y2="18"/><line x1="6" y1="12" x2="18" y2="12"/></svg>';
  var ICON_OUT = '<svg viewBox="0 0 24 24" aria-hidden="true"><line x1="6" y1="12" x2="18" y2="12"/></svg>';
  var ICON_RESET = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="5" width="14" height="14" rx="2"/></svg>';

  function setup(dialog) {
    var body = dialog.querySelector('.dn-zoom__body');
    if (!body || body.dataset.dnZoomPan === '1') return;
    body.dataset.dnZoomPan = '1';

    var base = 1;
    var scale = 1;
    var tx = 0;
    var ty = 0;
    var pts = new Map();
    var pinchDist = 0;
    var pinchScale = 1;
    var dragging = false;
    var moved = false;
    var lx = 0;
    var ly = 0;

    var ctrl = document.createElement('div');
    ctrl.className = 'dn-zoom__ctrl';
    ctrl.innerHTML =
      '<button type="button" data-z="out" aria-label="Zoom out">' + ICON_OUT + '</button>' +
      '<button type="button" data-z="reset" aria-label="Fit to screen">' + ICON_RESET + '</button>' +
      '<button type="button" data-z="in" aria-label="Zoom in">' + ICON_IN + '</button>';
    body.appendChild(ctrl);

    var btnIn = ctrl.querySelector('[data-z="in"]');
    var btnOut = ctrl.querySelector('[data-z="out"]');

    function inCtrl(target) {
      return !!(target && target.closest && target.closest('.dn-zoom__ctrl'));
    }

    function img() { return body.querySelector('img'); }

    function inner() {
      var cs = getComputedStyle(body);
      return {
        w: body.clientWidth - parseFloat(cs.paddingLeft || 0) - parseFloat(cs.paddingRight || 0),
        h: body.clientHeight - parseFloat(cs.paddingTop || 0) - parseFloat(cs.paddingBottom || 0)
      };
    }

    function computeBase() {
      var el = img();
      if (!el || !el.clientWidth || !el.clientHeight) return 1;
      var box = inner();
      var f = Math.min(box.w / el.clientWidth, box.h / el.clientHeight);
      if (!isFinite(f) || f <= 1) return 1;
      return Math.min(f, 3);
    }

    function clamp() {
      var el = img();
      if (!el) return;
      var box = inner();
      var maxX = Math.max(0, (el.clientWidth * scale - box.w) / 2);
      var maxY = Math.max(0, (el.clientHeight * scale - box.h) / 2);
      tx = Math.min(maxX, Math.max(-maxX, tx));
      ty = Math.min(maxY, Math.max(-maxY, ty));
    }

    function render(anim) {
      var el = img();
      if (!el) return;
      if (anim) {
        body.classList.add('is-animating');
        setTimeout(function () { body.classList.remove('is-animating'); }, 240);
      }
      clamp();
      el.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
      body.classList.toggle('is-zoomed', scale > base * 1.01);
      btnOut.disabled = scale <= base * 1.01;
      btnIn.disabled = scale >= base * 4 * 0.99;
    }

    function zoomAt(next, cx, cy, anim) {
      next = Math.min(base * 4, Math.max(base, next));
      var r = body.getBoundingClientRect();
      var px = (cx == null ? r.width / 2 : cx - r.left) - r.width / 2;
      var py = (cy == null ? r.height / 2 : cy - r.top) - r.height / 2;
      tx = px - (px - tx) * (next / scale);
      ty = py - (py - ty) * (next / scale);
      scale = next;
      if (scale <= base * 1.001) { tx = 0; ty = 0; }
      render(anim);
    }

    function reset(anim) {
      var el = img();
      if (el) el.style.transform = 'none';
      moved = false;
      base = computeBase();
      scale = base;
      tx = 0;
      ty = 0;
      render(anim);
    }

    ctrl.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button') : null;
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      if (b.dataset.z === 'in') zoomAt(scale * 1.6, null, null, true);
      else if (b.dataset.z === 'out') zoomAt(scale / 1.6, null, null, true);
      else reset(true);
    });

    body.addEventListener('wheel', function (e) {
      e.preventDefault();
      zoomAt(scale * (e.deltaY < 0 ? 1.12 : 1 / 1.12), e.clientX, e.clientY, false);
    }, { passive: false });

    body.addEventListener('dblclick', function (e) {
      if (inCtrl(e.target)) return;
      e.preventDefault();
      e.stopPropagation();
      if (scale > base * 1.01) reset(true);
      else zoomAt(base * 2.5, e.clientX, e.clientY, true);
    });

    body.addEventListener('pointerdown', function (e) {
      if (inCtrl(e.target)) return;
      moved = false;
      try { body.setPointerCapture(e.pointerId); } catch (err) {}
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pts.size === 2) {
        var a = Array.from(pts.values());
        pinchDist = Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y) || 1;
        pinchScale = scale;
        dragging = false;
      } else if (pts.size === 1 && scale > base * 1.01) {
        dragging = true;
        lx = e.clientX;
        ly = e.clientY;
        body.classList.add('is-panning');
      }
    });

    body.addEventListener('pointermove', function (e) {
      if (!pts.has(e.pointerId)) return;
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pts.size === 2) {
        var a = Array.from(pts.values());
        var d = Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y) || 1;
        moved = true;
        zoomAt(pinchScale * (d / pinchDist), (a[0].x + a[1].x) / 2, (a[0].y + a[1].y) / 2, false);
      } else if (dragging) {
        if (Math.abs(e.clientX - lx) > 2 || Math.abs(e.clientY - ly) > 2) moved = true;
        tx += e.clientX - lx;
        ty += e.clientY - ly;
        lx = e.clientX;
        ly = e.clientY;
        render(false);
      }
    });

    function release(e) {
      pts.delete(e.pointerId);
      if (pts.size < 2) pinchDist = 0;
      if (pts.size === 0) {
        dragging = false;
        body.classList.remove('is-panning');
      }
    }
    body.addEventListener('pointerup', release);
    body.addEventListener('pointercancel', release);

    body.addEventListener('click', function (e) {
      if (inCtrl(e.target)) return;
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    var mo = new MutationObserver(function () { setTimeout(function () { reset(false); }, 30); });
    mo.observe(body, { childList: true, attributes: true, attributeFilter: ['src'], subtree: true });

    dialog.addEventListener('close', function () { reset(false); });
    window.addEventListener('resize', function () { reset(false); });

    var el = img();
    if (el && !el.complete) el.addEventListener('load', function () { reset(false); }, { once: true });
    setTimeout(function () { reset(false); }, 50);
  }

  var queued = false;
  function scan() {
    queued = false;
    var list = document.querySelectorAll('dialog.dn-zoom');
    for (var i = 0; i < list.length; i++) setup(list[i]);
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(scan);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
